var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 10.8C2.4 6.16081 6.16081 2.4 10.8 2.4C15.4392 2.4 19.2 6.16081 19.2 10.8C19.2 13.0632 18.305 15.1173 16.8496 16.6277C16.8086 16.6593 16.7691 16.6939 16.7315 16.7315C16.6939 16.7691 16.6593 16.8085 16.6278 16.8496C15.1173 18.305 13.0632 19.2 10.8 19.2C6.16081 19.2 2.4 15.4392 2.4 10.8ZM17.5412 19.2383C15.6936 20.7162 13.35 21.6 10.8 21.6C4.83533 21.6 0 16.7647 0 10.8C0 4.83533 4.83533 0 10.8 0C16.7647 0 21.6 4.83533 21.6 10.8C21.6 13.35 20.7162 15.6936 19.2383 17.5412L23.6486 21.9515C24.1172 22.4201 24.1172 23.1799 23.6486 23.6485C23.1799 24.1172 22.4201 24.1172 21.9515 23.6485L17.5412 19.2383Z",
    fill: "#47465F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearch);
export default __webpack_public_path__ + "static/media/icn-search.d7288ebfb264cd6ca22c37b13236969b.svg";
export { ForwardRef as ReactComponent };